import React from 'react';
import Footer from '../component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap is included for styling

const GeneralUro = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">General Urology Care</h1>

        <section className="mb-4">
          <h2>Urinary Incontinence Treatment - Effective Solutions for Urinary Leakage</h2>
          <p className="text-justify">
            Urinary incontinence is a common issue that affects both men and women, leading to involuntary urine leakage or urgency. It can result from an overactive bladder, and while it can be embarrassing, effective treatments are available.
          </p>
          <p className="text-justify">
            We offer a range of therapies to manage incontinence, including bladder control exercises, lifestyle changes, and medications. For severe cases, we may recommend electric nerve stimulation (neuromodulation), bladder Botox therapy, or surgery if necessary. We work closely with our patients to find the best treatment to improve their quality of life.
          </p>
        </section>

        <section className="mb-4">
          <h2>Blood in Urine (Hematuria)</h2>
          <p className="text-justify">
            The presence of blood in the urine (hematuria) can be a sign of various conditions, including kidney infections, kidney stones, or more serious issues like bladder or kidney cancer. If you notice your urine is pink, red, or brownish-red, it’s important to seek medical attention immediately.
          </p>
          <p className="text-justify">
            We conduct thorough evaluations, including urine analysis, imaging tests, and cystoscopy, to identify the underlying cause of hematuria. Early detection is crucial for effective treatment, particularly in cases involving cancer or other serious urological conditions.
          </p>
        </section>

        <section className="mb-4">
          <h2>Testicular Infection Treatment</h2>
          <p className="text-justify">
            Testicular infections, often caused by bacterial infections, can lead to inflammation in the epididymis, a coiled tube at the back of the testicles responsible for storing and transporting sperm. This condition, known as epididymitis, can result from sexually transmitted diseases such as gonorrhea or chlamydia.
          </p>
          <p className="text-justify">
            Symptoms include painful urination, swelling or redness in the scrotum, and discharge from the penis. We offer medical treatments for epididymitis and other testicular infections, including antibiotics to fight infections and pain management strategies to alleviate discomfort. Our team is dedicated to providing care that addresses both the physical symptoms and emotional well-being of our patients.
          </p>
        </section>

        <section className="mb-4">
          <h2>Overactive Bladder (OAB)</h2>
          <p className="text-justify">
            Overactive bladder is a condition characterized by frequent urination, urgency, and in some cases, incontinence. It occurs when the muscles of the bladder contract involuntarily, causing a frequent and sudden urge to urinate.
          </p>
          <p className="text-justify">
            OAB is treated through lifestyle changes, such as fluid management, dietary adjustments (avoiding irritants like caffeine), and bladder training exercises. Medications such as anticholinergics (e.g., tolterodine) can relax the bladder muscles. Surgery may be considered if other treatments are ineffective.
          </p>
        </section>

        <section className="text-center">
          <p>If you are experiencing any urological symptoms or have concerns about your health, please contact us for a consultation with Dr. Aditya Sharma. Let us help you regain control of your health and improve your quality of life.</p>
        </section>

        <Footer />
      </div>
    </>
  );
}

export default GeneralUro;
